// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'
import { FC } from 'react'

import { Logo } from '@syconium/little-miss-figgy'

import { useSession } from '../../../app/_providers/SessionProvider.client'
import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { trackEvent } from '../../../lib/analytics'

import { LogoBody } from './styles'

export const NavLogo: FC = () => {
  const {
    magnolia: { navigation: strings },
  } = useTranslation()
  const {
    attributes: { stylePreference },
  } = useSession()

  const href = stylePreference ? `/pages/${stylePreference}-home` : '/'

  return (
    <LogoBody>
      <Link
        href={href}
        title={strings.logoTitle}
        {...trackEvent({ category: 'navigation', action: 'click logo' })}
      >
        <Logo fill={'currentColor'} aria-hidden='true' />
      </Link>
    </LogoBody>
  )
}
